import { IconSearch } from "@tabler/icons-react";

/**
 * Botón del header que abre la command palette · despacha el mismo
 * `KeyboardEvent` (Ctrl+K) que el atajo global, así la palette solo
 * necesita escuchar teclado (single source, ver `use-command-palette-shortcut.ts`).
 */
export function SearchTrigger() {
  function dispararCtrlK() {
    window.dispatchEvent(new KeyboardEvent("keydown", { key: "k", ctrlKey: true }));
  }
  return (
    <button
      type="button"
      onClick={dispararCtrlK}
      className={[
        "flex h-[34px] max-w-[520px] flex-1 items-center gap-2 rounded-xl border px-3 text-xs text-muted-foreground transition-colors shadow-2xs",
        "border-border bg-muted/50 hover:border-ink-300 hover:bg-muted",
      ].join(" ")}
    >
      <IconSearch size={15} stroke={1.6} />
      <span className="flex-1 text-left">Buscar por folio, proveedor o RFC…</span>
      <span className="ml-auto hidden font-mono text-[11px] text-muted-foreground sm:inline">(Ctrl+K)</span>
    </button>
  );
}
